module.exports = __webpack_public_path__ + "img/um.svg";